<template>
  <div class="relative" ref="dropdownRef">
    <!-- `ml-3` / `ml-1` / `left-0` -> the logical pair (§8.1). Zero pixels in a permanently-RTL
         panel, but this menu is on every screen all day and it is the file an agent copies when
         adding the next header control. `mt-[17px]` was an arbitrary offset for no stated reason;
         `mt-4` is the nearest step on the scale and the 1px is not load-bearing. -->
    <button type="button" class="flex h-9 items-center gap-2 rounded-lg pe-2 text-gray-700 transition hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800" :aria-expanded="dropdownOpen" aria-label="منوی حساب کاربری" @click.prevent="toggleDropdown">
      <span class="block max-w-24 truncate text-xs font-medium" :title="adminUser.name">{{ adminUser.name }}</span>
      <ChevronDown class="h-3.5 w-3.5 text-gray-400 transition-transform" :class="{ 'rotate-180': dropdownOpen }" aria-hidden="true" />
    </button>

    <div
      v-if="dropdownOpen"
      class="absolute end-0 mt-4 flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-lg dark:border-gray-800 dark:bg-gray-900"
    >
      <div>
        <span class="block text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ adminUser.name }}
        </span>
        <!-- An email is an identifier a person copies verbatim, so R-C6 gives it `dir="ltr"` and
             `font-mono` rather than letting a Latin string run inside an RTL block. -->
        <span class="mt-0.5 block break-all font-mono text-xs text-gray-500 dark:text-gray-400" dir="ltr">
          {{ adminUser.email }}
        </span>
      </div>

      <ul class="flex flex-col gap-1 pt-4 pb-3 border-b border-gray-200 dark:border-gray-800">
        <li>
          <router-link
            to="/profile"
            class="group flex h-9 items-center gap-3 rounded-lg px-3 text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/5"
            @click="closeDropdown"
          >
            <UserCircle class="h-5 w-5 text-gray-500" />
            {{ t('nav.profile') }}
          </router-link>
        </li>
      </ul>

      <button
        type="button"
        class="group mt-3 flex h-9 w-full items-center gap-3 rounded-lg px-3 text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/5"
        @click="handleLogout"
      >
        <LogOut class="h-5 w-5 text-gray-500" />
        {{ t('auth.logout') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { UserCircle, ChevronDown, LogOut } from 'lucide-vue-next'
import { logout, currentAdmin } from '@/services/auth'

const { t } = useI18n()
const router = useRouter()

const dropdownOpen = ref(false)
const dropdownRef = ref(null)
const adminUser = ref({ name: '', email: '' })

const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value
}

const closeDropdown = () => {
  dropdownOpen.value = false
}

const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    closeDropdown()
  }
}

const handleLogout = async () => {
  closeDropdown()
  await logout()
  router.push({ name: 'Signin' })
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
  const stored = currentAdmin()
  adminUser.value = stored
    ? { email: stored.email || '', name: stored.name || stored.email || 'مدیر' }
    : { name: 'مدیر', email: '' }
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
